export const getTimezone = function ({ lat, lng }: { lat: number; lng: number }): Promise<string> {
  const url = `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${Math.floor(
    Date.now() / 1000,
  )}&key=${process.env.REACT_APP_GOOGLE_KEY}`;
  console.log('url', url);
  return fetch(url)
    .then((res) => {
      if (res.status == 200) return res.json();
      throw new Error('Failed to getTimezone');
    })
    .then((data) => {
      if (data.timeZoneId) return data.timeZoneId;
      console.log('data', data);
      throw new Error(data.errorMessage || 'Failed to get Timezone');
    });
};
